var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#downloaded)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#7D35BC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F9FC",
    fillRule: "evenodd",
    d: "M4.938 11.063c0-.242.195-.438.437-.438h5.25a.438.438 0 0 1 0 .875h-5.25a.438.438 0 0 1-.438-.438Zm1.44-3.372c.171-.171.448-.171.619 0l.566.565V4.937a.437.437 0 1 1 .875 0v3.32l.565-.566a.438.438 0 0 1 .619.618L8.309 9.622a.437.437 0 0 1-.618 0L6.378 8.309a.438.438 0 0 1 0-.618Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "downloaded"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloaded);
export default __webpack_public_path__ + "static/media/downloaded.85eb10b8a2a1e78438186c8bc1a9fee4.svg";
export { ForwardRef as ReactComponent };